import { CheckboxListOption } from 'ia-react-core';
import { useLocation } from 'react-router';

export default function useCheckBoxDefaultValue(paramName: string, options: CheckboxListOption<string>[]): string[] {
  const { search } = useLocation();
  const queryStringValue = new URLSearchParams(search).get(paramName);
  const queryStringValues: string[] = queryStringValue?.split('|');
  return options.filter((option) => queryStringValues?.includes(option.value)).map((x) => x?.value);
}
